[
{"cluster_name":"Agriculture","cluster_name_short":"Agricultural Goods","cluster_col":"#EAC218"},
{"cluster_name":"Construction, Building, and Home Supplies","cluster_name_short":"Construction Goods","cluster_col":"#D1852A"},
{"cluster_name":"Electronic and Electrical Goods","cluster_name_short":"Electronics","cluster_col":"#52E2DE"},
{"cluster_name":"Industrial Chemicals and Metals","cluster_name_short":"Chemicals and Basic Metals","cluster_col":"#A42DE2"},
{"cluster_name":"Metalworking and Electrical Machinery and Parts","cluster_name_short":"Metalworking and Machinery","cluster_col":"#C64646"},
{"cluster_name":"Minerals","cluster_name_short":"Minerals","cluster_col":"#7C6760"},
{"cluster_name":"Textile and Home Goods","cluster_name_short":"Textile and Home Goods","cluster_col":"#757777"},
{"cluster_name":"Textile Apparel and Accessories","cluster_name_short":"Apparel","cluster_col":"#36B250"}
]
